import React from 'react';

const VolunteerForm: React.FC = () => {
  return (
    <section className="text-white p-6 text-center flex-auto">
      <iframe title="Volunteer Form" src="https://docs.google.com/forms/d/e/1FAIpQLSesuALL4TBXVKIFwf6jAIrLvKxIgsThD9DaG-YR5aGfp-QFag/viewform?embedded=true" width="100%" height="1200" frameBorder="0" marginHeight={0} marginWidth={0}>Loading…</iframe>
    </section>
  );
};

export default VolunteerForm;